/*
* @Author: 15620
* @Date:   2018-04-23 16:23:24
* @Last Modified by:   15620
* @Last Modified time: 2018-04-23 16:51:15
*/
import _ from 'lodash'

export default{
  install: function (Vue, name = '$lodash') {
    Object.defineProperty(Vue.prototype, name, {value: _})
  }
}



// WEBPACK FOOTER //
// ./src/plugins/lodash.js